module.exports = __webpack_public_path__ + "static/media/shape2.fff3d827.png";